import React, { useState } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  Grid,
  Hidden, Tooltip,
  Typography,
} from "@material-ui/core";

import {
  Menu as MenuIcon,
  ArrowBackIos
} from "@material-ui/icons";

import {
  IconButton,
  AppBar,
  IconButtonGroup,
  Toolbar,
  ToParent
} from "./styles";
import UserMenu from "./UserMenu";
import { DashboardRoutes } from "../../routes";

import {
  setViewMode,
  getTranscripts,
  getTranscript
} from "../../store/transcripts/transcriptsActions";
import { SvgRefreshIcon } from "../SvgIcon";
import { getTrashData } from "../../store/trash/trashActions";

const Header = (props) => {
  const {
    onDrawerToggle,
    history,
    match,
    getTranscripts,
  } = props;
  const [ isRefreshing, setIsRefreshing ] = useState(false);

  let isChild = false;
  let parent;
  let parentName;

  if (history.location.state) {
    isChild = true;
    parent = history.location.state;
  }

  if (parent) {
    parentName = DashboardRoutes.filter(item => item.path === `/${parent}`)[0].name;
  }

  const onRefresh = async () => {
    if (!isRefreshing) {
      setIsRefreshing(true);
      if (match.path.split('/').pop() === 'transcripts') {
        await getTranscripts(window.location.search);
        setIsRefreshing(false);
      }
    }
  };

  return (
    <React.Fragment>
      <AppBar position="relative" elevation={0}>
        <Toolbar>
          <Grid container alignItems="center">
            <Hidden mdUp>
              <Grid item>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={onDrawerToggle}
                >
                  <MenuIcon/>
                </IconButton>
              </Grid>
            </Hidden>
            <Grid item xs>
              {
                isChild &&
                  <ToParent
                    component={Link}
                    to={`/${parent}`}
                  >
                    <ArrowBackIos />
                    <Typography component={`span`}>
                      { parentName }
                    </Typography>
                  </ToParent>
              }
            </Grid>
            <Grid item>
              <Grid container alignItems="center">
                <IconButtonGroup>
                  {
                    match.path === '/transcripts' &&
                    <Tooltip title="Refresh">
                      <IconButton
                        onClick={() => onRefresh()}
                        color="inherit"
                        className={`refresh-btn ${isRefreshing}`}
                      >
                        <SvgRefreshIcon/>
                      </IconButton>
                    </Tooltip>
                  }
                  {/*<Notifications/>*/}
                </IconButtonGroup>
                <UserMenu history={history}/>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  viewMode: state.transcriptsReducer.viewMode,
  loading: state.transcriptsReducer.loading
});

const mapDispatchToProps = {
  getTranscripts,
  getTranscript,
  getTrashData,
  setViewMode
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
